import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Icon, IconButton } from '@material-ui/core';

import * as Actions from './store/actions';
import * as ActionsDialog from 'app/store/actions';
import * as ClustersActions from 'app/main/cluster/store/actions';
import * as ProviderActions from 'app/store/actions';
import * as CredentialsActions from '../credentials/store/actions';

import QuickJobForm from './QuickJobForm';
import { handleGetClusters } from '../cluster/util';

const QuickJob = () => {
	const dispatch = useDispatch();

	const open = useSelector(({ fuse }) => fuse.dialog.state);
	const clusters = useSelector(({ clusters }) => clusters.cluster.list);
	const credentials = useSelector(({ credentials }) => credentials.credential.list);
	const providers = useSelector(({ providers }) => providers.providers.list);
	const jobs = useSelector(({ jobs }) => jobs.job.list);
	const user = useSelector(({ auth }) => auth.user);

	useEffect(() => {
		if (open) {
			if (clusters.length === 0) handleGetClusters(dispatch, ClustersActions, user);
			if (credentials.length === 0 && user.role.includes('admin')) dispatch(CredentialsActions.getCredentials(true));
			if (providers.length === 0) dispatch(ProviderActions.getProviders());
			if (jobs.length === 0) dispatch(Actions.getJobs());
		}
	}, [dispatch, open, clusters.length, credentials.length, providers.length, jobs.length, user]);

	const handleJobSubmit = () => {
		dispatch(
			ActionsDialog.openDialog({
				children: <QuickJobForm />,
				maxWidth: 'sm',
				fullWidth: true,
				onClose: (event, reason) => {
					if (reason !== 'backdropClick') {
						dispatch(ActionsDialog.closeDialog());
					}
				}
			})
		);
	};
	const containerStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		floating: "left",
		top: '10px',
		right: '143px',
		zIndex: '999'
	};

	return (
		<div style={containerStyle}>
			<IconButton id="quick_job_submit-btn" onClick={() => handleJobSubmit()}>
				<Icon style={{ color: '#ffffff' }}>work_outline</Icon>
			</IconButton>
		</div>
	);
};

export default QuickJob;
